export const viewTypes = {
  DOCUMENT: 'document',
  PROJECT: 'project',
  ISSUE_DETAILS_MODAL: 'issueDetailsModal',
  ADMIN: 'admin'
};
